import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import MaterialCircularProgress, {
  CircularProgressProps as MaterialCircularProgressProps
} from '@material-ui/core/CircularProgress';
import Portal from '@material-ui/core/Portal';
const useStyles = (size: number, opacity = 0.6, x = 50, y = 50): Function =>
  makeStyles<Theme>(() => {
    const xOffset = `calc(${x}% - ${size / 2}rem)`;
    const yOffset = `calc(${y}% - ${size / 2}rem)`;
    return {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `rgba(0, 0, 0, ${opacity})`,
        zIndex: 1300
      },
      spinner: {
        position: 'fixed',
        margin: '0 auto',
        top: yOffset,
        left: xOffset
      }
    };
  });

export interface CircularProgressProps extends MaterialCircularProgressProps {
  loading?: boolean;
  withinContainer?: boolean;
  size?: number;
  xOffset?: number;
  yOffset?: number;
  overlayOpacity?: number;
}

const appRoot = document.getElementById('root');

const CircularProgress: React.FC<CircularProgressProps> = ({
  loading,
  color = 'primary',
  size = 6.5,
  thickness,
  xOffset,
  yOffset,
  overlayOpacity,
  ...rest
}) => {
  const classes = useStyles(size, overlayOpacity, xOffset, yOffset)();
  if (!loading) return null;
  return (
    <Portal container={appRoot}>
      <div className={classes.overlay}>
        <MaterialCircularProgress
          className={classes.spinner}
          color={color}
          size={`${size}rem`}
          thickness={thickness || size * 0.7}
          {...rest}
        />
      </div>
    </Portal>
  );
};

export default CircularProgress;
